import $ from "cash-dom";

$(document).ready(() => {
    const section = $('#documents').get(0);
    const $documents = $('#documents-list');
    const getParams = new URLSearchParams(window.location.search);
    const category = getParams.get('category');
    const anchor = location.hash;

    if (category) {
        $documents.children().each((n, e) => {
            if (e.getAttribute('data-category') === category)
                $(e).show();
            else
                $(e).hide();
        });
        section.style.display = 'block';
    }

    if (anchor)
        $(anchor)[0].scrollIntoView();
});
